(() => {
  const normalize = (s) =>
    (s || "")
      .replace(/\s+/g, " ")
      .trim()
      .toLowerCase();

// On cible les liens/boutons dont le libellé contient "télécharger" OU "download"
const isDownloadLabel = (el) => {
  const text = normalize(el.textContent);
  return text.includes("télécharger") || text.includes("download");
};


  const filenameFromUrl = (url) => {
    try {
      const u = new URL(url);
      const last = (u.pathname.split("/").pop() || "image").split("?")[0];
      return last || "image";
    } catch {
      return "image";
    }
  };

  /**
   * Essaie de remonter vers le fichier original Shopify si l'URL est une variante.
   * - Retire les paramètres de resize (?width=..., &height=..., &crop=...)
   * - Retire les suffixes du type _800x, _1024x1024 avant l'extension
   */
  const toShopifyOriginalUrl = (url) => {
    let out = url;

    // 1) Enlève les paramètres courants de resize
    try {
      const u = new URL(out);
      ["width", "height", "crop"].forEach((p) => u.searchParams.delete(p));
      out = u.toString();
    } catch {
      // ignore
    }

    // 2) Enlève les suffixes Shopify type _800x, _800x800, etc.
    // Ex: photo_1200x.jpg -> photo.jpg
    out = out.replace(
      /_(\d+x\d+|\d+x)\.(jpg|jpeg|png|webp|gif|avif)(\?.*)?$/i,
      ".$2$3"
    );

    return out;
  };

  document.addEventListener(
    "click",
    async (e) => {
      const el = e.target.closest("a, button");
      if (!el) return;
      if (!isDownloadLabel(el)) return;

      // Cas <a href="..."> (le plus fréquent)
      let url = el.getAttribute("href") || el.dataset.href;
      if (!url) return;

      e.preventDefault();
      e.stopPropagation();

      // 🔥 On force l'URL "originale" si possible
      const originalUrl = toShopifyOriginalUrl(url);

      try {
        const res = await fetch(originalUrl, { mode: "cors", credentials: "omit" });
        if (!res.ok) throw new Error("Fetch failed");

        const blob = await res.blob();
        const objectUrl = URL.createObjectURL(blob);

        const a = document.createElement("a");
        a.href = objectUrl;
        a.download = filenameFromUrl(originalUrl); // nom basé sur l’original
        document.body.appendChild(a);
        a.click();
        a.remove();

        URL.revokeObjectURL(objectUrl);
      } catch (err) {
        // fallback : ouvre l'URL originale (ou l'URL initiale)
        window.open(originalUrl || url, "_blank", "noopener,noreferrer");
      }
    },
    true
  );
})();
